import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFedoraComponent } from './simple-icons-fedora.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFedoraComponent ],
    exports:      [ SimpleIconsFedoraComponent ],
    bootstrap:    []
})
export class SimpleIconsFedoraModule {}
